export default {"src":"/_next/static/media/microsoft-365.4322073e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};